import Vue from "vue"
import VueRouter from "vue-router"
//import Home from "../views/home.vue"
import Static from "../views/static-page.vue"
// import HomeNav from "../views/home-nav.vue"
//import Test from "../views/test.vue"
//import mhero from "../views/mhero/mhero.vue"
//import contactGroups from "../views/mhero/contact-groups.vue"

Vue.use(VueRouter)

const routes = [
    //    {
    //   path: "/",
    //   name: "home",
    //   components: {
    //     default: Static,
    //     homeNav: HomeNav
    //   },
    //   props: { default: { id: "page-home", blankOnErr: true } }
    // },
    {
        path: "/",
        name: "home",
        props: {default: {id: "page-home", blankOnErr: true}},
        component: () => import(/* webpackChunkName: "home" */ "../views/home"),
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('../views/auth/reset-password.vue')
    },
    {
        path: '/change-password',
        name: 'change-password',
        component: () => import('../views/auth/change-password.vue')
    },
    {
        path: "/import",
        name: "import",
        component: () =>
            import(/* webpackChunkName: "mhero" */ "../views/importExport/import.vue"),
    },
    {
        path: "/positionStock",
        name: "positionStock",
        component: () =>
            import(/* webpackChunkName: "mhero" */ "../views/PositionStock/index.vue"),
    },
    {
        path: "/export",
        name: "export",
        component: () =>
            import(/* webpackChunkName: "mhero" */ "../views/importExport/export.vue"),
    },
    {
        path: "/leave-request",
        name: "leave-request",
        component: () =>
            import(/* webpackChunkName: "mhero" */ "../views/leaveRequest/approve-leave-request.vue"),
    },
    {
        path: "/printId/:id",
        name: "print-id",
        component: () =>
            import(/* webpackChunkName: "mhero" */ "../views/printId/print-id.vue"),
    },
    {
        path: "/page/mhero",
        name: "mhero",
        component: () =>
            import(/* webpackChunkName: "mhero" */ "../views/mhero/mhero.vue"),
    },
    {
        path: "/page/mhero-scheduled-message",
        name: "mhero-scheduled-message",
        component: () =>
            import(
                /* webpackChunkName: "mhero" */ "../views/mhero/mhero-scheduled-message.vue"
                ),
    },
    {
        path: "/page/contact-groups",
        name: "contact-groups",
        component: () =>
            import(
                /* webpackChunkName: "mhero" */ "../views/mhero/contact-groups.vue"
                ),
    },
    {
        path: "/page/mhero-reports",
        name: "mhero-reports-base",
        component: () =>
            import(
                /* webpackChunkName: "mhero" */ "../views/mhero/mhero-reports-base.vue"
                ),
    },
    {
        path: "/report/:report",
        name: "mhero-reports",
        component: () =>
            import(
                /* webpackChunkName: "mhero" */ "../views/mhero/mhero-reports.vue"
                ),
    },
    /*
      {
        path: "/test/:id",
        name: "test",
        component: Test
      },
      */
    {
        path: "/static/:id",
        name: "static",
        //component: () => import( /* webpackChunkName: "static" */ "../views/static-page.vue")
        component: Static,
    },
    //{
    //path: "/resource/:type/:page/:id?",
    //name: "resource_page",
    //// route level code-splitting
    //// this generates a separate chunk (about.[hash].js) for this route
    //// which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "resource" */ "../views/fhir-page-resource.vue")
    //},
    {
        path: "/resource/view/:page/:id",
        name: "resource_view",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "resource" */ "../views/fhir-page-view.vue"),
    },
    {
        path: "/resource/search/:page",
        name: "resource_search",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
                /* webpackChunkName: "resource" */ "../views/fhir-page-search.vue"
                ),
    },
    {
        path: "/resource/report/:report",
        name: "resource_report",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "report" */ "../views/fhir-report.vue"),
    },
    {
        path: "/resource/add/:page",
        name: "resource_add",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
                /* webpackChunkName: "resource-add" */ "../views/fhir-page-add.vue"
                ),
    },
    {
        path: "/questionnaire/:questionnaire/:page",
        name: "questionnaire",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/fhir-page-questionnaire.vue"
                ),
    },
    {
        path: "/dashboard/:id",
        name: "dashboard",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
                /* webpackChunkName: "dashboard" */ "../views/kibana-dashboard.vue"
                ),
    },
    {
        path: "/bulk-registration",
        name: "bulk_registration",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/bulk-registration"
                ),
    },
    {
        path: "/facility-from-mfr",
        name: "facility_from_mfr",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/mfr-data"
                ),
    },
    {
        path: "/adminUnit/by-location",
        name: "by-location",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/admin-unit-by-location"
                ),
    },
    {
        path: "/adminUnit/by-reporting",
        name: "by-reporting",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/admin-unit-by-reporting"
                ),
    },

    {
        path: "/audit-event",
        name: "audit_event",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/fhir-event-audit"
                ),
    },
    {
        path: "/languageDetail/:id",
        name: "languageDetail",
        component: () =>
            import(/* webpackChunkName: "questionnaire" */ "../views/languageDetail"),
    },
    {
        path: "/aggregateReport/performance",
        name: "aggregatePerformanceReport",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/Aggregate/performance.vue"
                ),
    },
    {
        path: "/aggregateReport/stockHealthWorkforce",
        name: "stockHealthWorkforce",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/Aggregate/stockHealthWorkforce.vue"
                ),
    },
    {
        path: "/aggregateReport/byGenderDistribution",
        name: "byGenderDistribution",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/Aggregate/byGenderDistribution.vue"
                ),
    },
    {
        path: "/aggregateReport/selectedHealthProfessional",
        name: "selectedHealthProfessional",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/Aggregate/selectedHealthProfessional.vue"
                ),
    },
    {
        path: "/aggregateReport/healthProfessionalsToPopulation",
        name: "healthProfessionalsToPopulation",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/Aggregate/healthProfessionalsToPopulation.vue"
                ),
    },
    {
        path: "/MainReport/career",
        name: "CareerReport",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/Reports/career.vue"
                ),
    },
    {
        path: "/aggregateReport/organization",
        name: "aggregateOrganizationReport",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/Aggregate/organization.vue"
                ),
    },
    {
        path: "/MainReport/dataCompleteness",
        name: "dataCompleteness",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/Aggregate/dataCompleteness.vue"
                ),
    },
    {
        path: "/customRole",
        name: "customerRole",
        component: () =>
            import(
                /* webpackChunkName: "questionnaire" */ "../views/role/custom-role.vue"
                ),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
})

export default router
